import { render, staticRenderFns } from "./CostBreakdownSubpaymentConfiguration.vue?vue&type=template&id=2d6608e6&scoped=true&"
import script from "./CostBreakdownSubpaymentConfiguration.vue?vue&type=script&lang=js&"
export * from "./CostBreakdownSubpaymentConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./CostBreakdownSubpaymentConfiguration.vue?vue&type=style&index=0&id=2d6608e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6608e6",
  null
  
)

export default component.exports